module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nb-tank-block"
  }, [_c('NbExpanding', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.edit && _vm.tank.procedure === _vm.tank.Procedure.FREE && !_vm.tank.exist()),
      expression: "edit && tank.procedure === tank.Procedure.FREE && !tank.exist()"
    }]
  }, [_c('div', [_c('span', {
    staticClass: "btn btn-primary btn-sm btn-file"
  }, [_c('i', {
    staticClass: "fa fa-folder-open-o"
  }), _vm._v(" "), _c('span', [_vm._v("选择文件")]), _vm._v(" "), _c('input', {
    ref: "refFile",
    attrs: {
      "type": "file",
      "name": "avatar"
    },
    on: {
      "change": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.fileChanged($event)
      }
    }
  })])]), _vm._v(" "), (!_vm.tank.errorMessage && _vm.tank.uploadHint) ? _c('div', {
    staticClass: "mt5 italic"
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  }), _vm._v(" " + _vm._s(_vm.tank.uploadHint) + "\n\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.tank.errorMessage) ? _c('div', {
    staticClass: "mt5 "
  }, [_c('i', {
    staticClass: "fa fa-warning text-danger"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.tank.errorMessage))])]) : _vm._e()])]), _vm._v(" "), _c('NbExpanding', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tank.procedure === _vm.tank.Procedure.FETCHING_UPLOAD_TOKEN),
      expression: "tank.procedure === tank.Procedure.FETCHING_UPLOAD_TOKEN"
    }]
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-fw"
  }), _vm._v(" 准备上传中...\n\t\t")])]), _vm._v(" "), _c('NbExpanding', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tank.mode === _vm.tank.Mode.TINY && _vm.tank.procedure === _vm.tank.Procedure.UPLOADING),
      expression: "tank.mode===tank.Mode.TINY && tank.procedure === tank.Procedure.UPLOADING"
    }]
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-fw"
  }), _vm._v(" 正在上传中...\n\n\t\t")])]), _vm._v(" "), _c('NbExpanding', [(_vm.tank.mode === _vm.tank.Mode.HUGE && (_vm.tank.procedure === _vm.tank.Procedure.UPLOADING)) ? _c('div', {
    staticClass: "huge-block clearfix"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('i', {
    staticClass: "btn-action f16 fa fa-trash text-danger",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.del()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_vm._v(_vm._s(_vm.tank.file.name))])]), _vm._v(" "), _c('div', {
    staticClass: "progress",
    class: {
      'progress-striped active': _vm.tank.procedure === _vm.tank.Procedure.UPLOADING
    }
  }, [_c('div', {
    staticClass: "progress-bar progress-bar-primary",
    style: ('width: ' + (_vm.tank.progress * 100) + '%')
  }, [_c('span', [_vm._v("已上传 " + _vm._s((_vm.tank.progress * 100).toFixed(1)) + "%")])])]), _vm._v(" "), _c('div', [_vm._v("\n\t\t\t\t已上传:" + _vm._s(_vm._f("humanFileSize")((_vm.tank.file.size * _vm.tank.progress).toFixed(0))) + "/" + _vm._s(_vm._f("humanFileSize")(_vm.tank.file.size)) + " 速度:" + _vm._s(_vm._f("humanFileSize")(_vm.tank.speed)) + "/s\n\n\t\t\t")])]) : _vm._e()]), _vm._v(" "), _c('NbExpanding', [(_vm.tank.exist()) ? _c('div', {
    staticClass: "tiny-block"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.preview && _vm.tank.publicImgUrl()),
      expression: "preview && tank.publicImgUrl()"
    }],
    staticClass: "w200 p10 mb10 bg-white br5 border"
  }, [_c('img', {
    staticClass: "wp100",
    attrs: {
      "src": _vm.tank.publicImgUrl()
    }
  })]), _vm._v(" "), _c('div', [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tank.fileIcon() && !_vm.tank.publicImgUrl()),
      expression: "tank.fileIcon() && !tank.publicImgUrl()"
    }],
    staticClass: "f16",
    class: [_vm.tank.fileIcon()]
  }), _vm._v(" "), _c('span', {
    staticClass: "f14 black cursor hover-underline",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.tank.download()
      }
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm.tank.name) + "\n\t\t\t")]), _vm._v(" "), _c('span', [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("humanFileSize")(_vm.tank.size)) + "\n\t\t\t")]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "btn-action f16 fa fa-download text-success",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.tank.download()
      }
    }
  })]), _vm._v(" "), (_vm.edit) ? _c('span', [_c('i', {
    staticClass: "btn-action f16 fa fa-trash text-danger",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.del()
      }
    }
  })]) : _vm._e()])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-6eb0bf90"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/common/widget/NbTank.vue
// module id = 1001
// module chunks = 1